<template lang="html">
  <div class="tab">
    <router-link to="/index">
        <img src="@/assets/tab/01.png" />
        <img src="@/assets/tab/01-1.png" />
        <div>首页</div>
      </router-link>
      <router-link to="/dynamic/news">
        <img src="@/assets/tab/02.png" />
        <img src="@/assets/tab/02-2.png" />
        <div>展会动态</div>
      </router-link>
      <router-link to="/">
        <img src="@/assets/tab/03.png" />
        <img src="@/assets/tab/03-3.png" />
        <div>报名登记</div>
      </router-link>
      <router-link to="/visit">
        <img src="@/assets/tab/04.png" />
        <img src="@/assets/tab/04-4.png" />
        <div>观展指南</div>
      </router-link>
      <router-link to="/contact">
        <img src="@/assets/tab/05.png" />
        <img src="@/assets/tab/05-5.png" />
        <div>联系我们</div>
      </router-link>
  </div>
</template>

<script>
export default {
    name:'tab',
    props:{
      text:{type:String,default:"暂无数据"}
    },
    data() {
        return {}
    }
}
</script>

<style scoped>
.tab{display:none;}

@media (max-width: 991px){
.tab{
  height: 54px; display: flex; justify-content: center;
  position: fixed; right:0; left:0; bottom:0; z-index:9999;
  background:#fff; border-top: 1px solid #ccc; 
}
.tab>a{flex: 1 1 25%; width:25%; display: flex; flex-wrap: wrap; text-decoration: none; font-size:12px; color:#333;}
.tab>a>div{height: 14px; line-height:14px; text-align:center; width:100%;}
.tab>a>img{width:25px; height:25px; margin: 7px auto 0 auto;}
.tab>a>img:nth-of-type(2){display: none;}
.tab>a.router-link-active{color:#0a3f9b;}
.tab>a.router-link-active img:nth-of-type(1){display: none;}
.tab>a.router-link-active img:nth-of-type(2){display: block;}
}
</style>
